// extracted by mini-css-extract-plugin
module.exports = {"section":"Search_section__1WK1v","label":"Search_label__2au2g","input":"Search_input__2BuOV","clear":"Search_clear__Sipjp"};